import apiClient from './apiClient';

const Url = `/auth`;

export const forgotPassword = async (email) => {
    try{
        if(!email) return false;
        let body = {
            "email" : email.trim(),
        }
        let response = await apiClient.post(`${Url}/forgot-password`, body);
        return response.data;
    }catch(error){
        console.log('error', error, error.response);
        return error.response?.data || error;
    }
}

/**
 * The backend's forgot-password flow is two steps: exchange the emailed OTP
 * for a one-time reset token, then use that token to actually set the new
 * password. The reset screen collects both in a single form, so this bridges
 * that into the two calls /auth/verify-otp and /auth/reset-password expect.
 */
export const resetPassword = async (body) => {
    try{
        if(!body) return false;
        const { email, resetToken, newPassword, newPassword2 } = body;

        const verifyResponse = await apiClient.post(`${Url}/verify-otp`, {
            email,
            otp: resetToken,
        });
        const verifiedToken = verifyResponse?.data?.data?.token;
        if (!verifiedToken) {
            return verifyResponse.data;
        }

        let response = await apiClient.post(`${Url}/reset-password`, {
            token: verifiedToken,
            newPassword,
            confirmPassword: newPassword2,
        });
        return response.data;
    }catch(error){
        console.log('error', error, error.response);
        return error.response?.data || error;
    }
}
